<template>
  <div :class="classes" :aria-hidden="!isVisible">
    <div class="explanation-header">{{ explanationHeader }}</div>
    <!-- eslint-disable vue/no-v-html -->
    <div class="explanation-details" v-html="sanitizedExplanation" />
    <!-- eslint-enable -->
  </div>
</template>

<script>
// @flow

import { sanitizedMarkup } from '../../../../../../common/utils'

export default {
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    message: {
      type: Object,
      default: () => {
      }
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sanitizedExplanation (): string {
      return sanitizedMarkup(this.item.explanation, this.message.content.messageId)
    },
    explanationHeader (): string {
      return this.message.content.explanationHeader || this.$t('product.explanationHeader')
    },
    classes () {
      return {
        explanation: true,
        'explanation--is-visible': this.isVisible
      }
    }
  }
}
</script>

<style src="./explanation.scss" />
